/**
 * Catálogo único de permisos del panel.
 *
 * Antes los strings vivían en cuatro capas sin fuente común: los guards del
 * backend (`requirePermission('x.y')`), la tabla `permissions` del seed, el mapa
 * de rutas del layout y los checks `can('x.y')` de cada página. Un typo entre
 * `payment_accounts.read` (backend) y `payment-accounts.read` (frontend) no
 * fallaba en compilación; con estas constantes el compilador lo detecta.
 *
 * Cada clave DEBE existir también en el seed del backend (migración incluida
 * cuando es nueva): este módulo es la vista del frontend del mismo catálogo.
 */
export const P = {
  customers: { read: 'customers.read', create: 'customers.create', update: 'customers.update', delete: 'customers.delete' },
  products: { read: 'products.read', create: 'products.create', update: 'products.update', delete: 'products.delete' },
  inventory: { read: 'inventory.read', update: 'inventory.update' },
  quotes: { read: 'quotes.read', create: 'quotes.create', update: 'quotes.update', delete: 'quotes.delete' },
  paymentAccounts: { read: 'payment_accounts.read', create: 'payment_accounts.create', update: 'payment_accounts.update', delete: 'payment_accounts.delete' },
  orders: { read: 'orders.read', create: 'orders.create', update: 'orders.update', delete: 'orders.delete' },
  payments: { read: 'payments.read', refund: 'payments.refund' },
  paymentGateways: { read: 'payment_gateways.read', update: 'payment_gateways.update' },
  leads: { read: 'leads.read', update: 'leads.update', delete: 'leads.delete' },
  ai: { chat: 'ai.chat', config: 'ai.config' },
  aiAgents: { create: 'ai.agents.create', read: 'ai.agents.read', update: 'ai.agents.update', delete: 'ai.agents.delete' },
  users: { read: 'users.read', create: 'users.create', update: 'users.update', delete: 'users.delete', assign: 'users.assign' },
  roles: { read: 'roles.read', create: 'roles.create', update: 'roles.update', delete: 'roles.delete', assign: 'roles.assign' },
  permissions: { read: 'permissions.read', update: 'permissions.update' },
  pages: { read: 'pages.read', create: 'pages.create', update: 'pages.update', delete: 'pages.delete' },
  forms: { read: 'forms.read', create: 'forms.create', update: 'forms.update', delete: 'forms.delete' },
  crm: { read: 'crm.read' },
  workflows: { read: 'workflows.read', create: 'workflows.create', update: 'workflows.update', delete: 'workflows.delete', publish: 'workflows.publish', execute: 'workflows.execute' },
  workflowCredentials: { manage: 'workflow_credentials.manage' },
  mail: { config: 'mail.config' },
  builder: { all: 'builder.*' },
  parameters: { read: 'parameters.read', create: 'parameters.create', update: 'parameters.update', delete: 'parameters.delete' },
  audit: { configure: 'audit.configure', read: 'audit.read' }
} as const

export type PermissionName = {
  [K in keyof typeof P]: (typeof P)[K][keyof (typeof P)[K]]
}[keyof typeof P]
